import { FaHistory } from "react-icons/fa";

export const TicketScheduleSection = ({ data }) => {
    return (
        <div className="relative border-l-2 border-slate-700 ml-2 space-y-6 pb-2">
        {data?.map((schedule, index) => {
          const isRescheduled = schedule?.status?.name === "Dijadwalkan Ulang";
          const isActive = schedule?.status?.name === "Akan Datang";

          return (
            <div key={schedule.id} className="relative pl-6">
              {/* <!-- Dot Indicator --> */}
              <div
                className="absolute -left-[9px] top-1 w-4 h-4 rounded-full border-2"
                style={{
                  background: isRescheduled ? "#0B1426" : isActive ? "#34d399" : "#0077B6",
                  borderColor: isRescheduled ? "#f87171" : isActive ? "#34d399" : "#0077B6",
                }}
              ></div>

              <div className="text-sm">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-bold text-slate-200">
                    {schedule.date}
                  </span>
                  <span className="text-slate-400">{schedule?.start_time} WIB</span>
                </div>

                <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider mb-2 ${isRescheduled
                    ? "bg-red-500/10 text-red-400 border border-red-500/20"
                    : isActive
                      ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20"
                      : "bg-slate-500/10 text-slate-400 border border-slate-500/20"
                  }`}>
                  {schedule?.status?.name}
                </span>

                {isRescheduled && schedule?.description && (
                  <div className="mt-2 p-2 rounded-lg bg-red-900/10 border border-red-900/20">
                    <div className="flex items-start gap-2">
                      <FaHistory className="text-red-400 mt-0.5 text-xs flex-shrink-0" />
                      <p className="text-xs text-red-300/80 leading-relaxed">
                        <span className="font-semibold text-red-400">Alasan:</span> {schedule?.description}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    )}